import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  template: `{{data[propertyName]}}`
})
export class DataBindingCellComponent implements ICellRendererAngularComp {

  data: any;
  propertyName: any;

  constructor() {}

  agInit(params: any): void {
    this.data = params.data;
    this.propertyName = params.colDef.field;
  }

  refresh(): boolean {
    return false;
  }
}
